define([
  "globals",
  "knockout",
  "jquery"],
function (globals, ko, $) {

  // THD Product Reviews module

  "use strict";

  var Reviews = function(productId, aliasId) {

    var self = this;
    self.productId = productId;
    self.aliasId = aliasId;
    self.hideReviews = ko.observable(true);

    self.isMobile = globals.ssm.getState("mobile").active;
    self.hideSection = ko.observable(self.isMobile);
    self.hasReviews = ko.observable(true);
    self.buttonText = ko.observable("Show individual reviews");
    self.starsWidth = ko.observable('100%');
    self.writeReviewLink = ko.observable('#');
    self.readReviewsLink = ko.observable('#');

    self.ratingWidth = function(ratingValue) {
      var percentage = ratingValue ? ((ratingValue / 5) * 100) : 0;
      return percentage + "%";
    };

    self.numReviews = ko.observable(0);
    self.scrollToSection = function(hash) {
      if ((hash == "testimonials" || hash == "BVRRWidgetID") && self.hasReviews()) {
        self.showContent();
        $("html, body").animate({
          scrollTop: $("#testimonials").offset().top
        }, 1000);
      }
    }

    self.getReviewData = function(callback) {

      if ($BV) {
        $BV.configure("global", {});
        $BV.ui("rr", "show_reviews", {
          productId: globals.partnerProductId,
          onEvent: function (result) {
            if (result.attributes.numReviews > 0) {
              const writeReviewLink = `https://www.homedepot.com/p/writeAReview?itemId=${result.productId}`;
              self.writeReviewLink(writeReviewLink);
              self.readReviewsLink(`https://www.homedepot.com/p/reviews/${result.urlPageName.substr(2)}/1?sort=Most-helpful&reviewsRating=0`)
              $('body').on('click', '#BVRRRatingSummaryLinkWriteID', function(event) {
                if ($('html').is('.mobile')) {
                  event.preventDefault();
                  event.stopImmediatePropagation();
                  window.location.href = writeReviewLink;
                }
              });
              self.numReviews(result.attributes.numReviews);
              self.starsWidth(self.ratingWidth(result.attributes.avgRating))
              if (result.eType == "Read" && result.eventSource == "Action" && result.eventTarget == "Review") {
                $("#bazaarVoice").removeClass("bdc-product-reviews-hide");
              }
              $("#reviews-header").show();

              if(window.location.hash) {
                $("html, body").animate({
                  scrollTop: $(window.location.hash).offset().top
                }, 1000);
              }

            } else {
              setTimeout(function () {
                $("#reviews-header").hide();
                $("#bazaarVoice").removeClass("bdc-product-reviews-hide");
                $(".BVRRLinkToContactUs").attr("href", "mailto:customblinds@homedepot.com");
              }, 1000);
            }
          }
        });
      }

      // Click behavior for THD
      $(window).on("hashchange", function () {
        var internalhash = window.location.hash.slice(1);
        if (internalhash == "BVRRWidgetID") {
          window.location.hash = "#testimonials";
          self.showContent();
        }
      });

    }

    self.showContent = function () {
      self.hideReviews(false);
      self.buttonText("Hide individual reviews");
    };

    this.toggleSection = function(viewModel, event) {
      self.hideSection(!self.hideSection());
      location.hash = "";
      if (history.pushState) {
        history.pushState("", document.title, window.location.pathname);
      }
      if (event && self.hideSection() === false) {
        event.preventDefault();
      }
    };

    this.toggleDetails = function () {
      self.hideReviews(!self.hideReviews());
      if (self.hideReviews()) {
        location.hash = "";
        self.buttonText("Show individual reviews");
      } else {
        if (!self.isMobile) {
          location.hash = "";
          location.hash = "#testimonials";
        }
        self.buttonText("Hide individual reviews");
      }
    };

  }

  return Reviews;

});
